import { defineMessages } from 'react-intl';

var messages = defineMessages({
  selectPlaceholder: {
    id: "neptune.MoneyInput.Select.placeholder"
  },
  searchPlaceholder: {
    id: "neptune.MoneyInput.Select.searchPlaceholder"
  },
  selectCurrencyLabel: {
    id: "neptune.MoneyInput.Select.selectCurrencyLabel"
  }
});

export { messages as default };
//# sourceMappingURL=MoneyInput.messages.mjs.map
